import { useState } from "react";
import { LuClock } from "react-icons/lu";
import { can } from "src/Common/function";
import GenerateReportModal from "./GenerateReportModal";
import RefrigerantReportModal from "./RefrigerantReportModal";
import RecommendationsReportModal from "./RecommendationsReportModal";

// Card icons. Use `currentColor` so the icon color follows the card's text-[...] class.
const OpenWorkOrdersIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.55 1.5C8.52239 1.5 8.5 1.52239 8.5 1.55V3H13V1.55C13 1.52239 12.9776 1.5 12.95 1.5H8.55ZM14.5 3V1.55C14.5 0.693958 13.806 0 12.95 0H8.55C7.69396 0 7 0.693958 7 1.55V3H3.15C1.4103 3 0 4.4103 0 6.15V15.35C0 17.0897 1.4103 18.5 3.15 18.5H18.35C20.0897 18.5 21.5 17.0897 21.5 15.35V6.15C21.5 4.4103 20.0897 3 18.35 3H14.5ZM3.15 4.5C2.23873 4.5 1.5 5.23873 1.5 6.15V10H8V9.55C8 8.69396 8.69396 8 9.55 8H11.95C12.806 8 13.5 8.69396 13.5 9.55V10H20V6.15C20 5.23873 19.2613 4.5 18.35 4.5H3.15ZM20 11.5H13.5V11.95C13.5 12.806 12.806 13.5 11.95 13.5H9.55C8.69396 13.5 8 12.806 8 11.95V11.5H1.5V15.35C1.5 16.2613 2.23873 17 3.15 17H18.35C19.2613 17 20 16.2613 20 15.35V11.5ZM9.5 11.95C9.5 11.9776 9.52239 12 9.55 12H11.95C11.9776 12 12 11.9776 12 11.95V9.55C12 9.52239 11.9776 9.5 11.95 9.5H9.55C9.52239 9.5 9.5 9.52239 9.5 9.55V11.95Z"
      fill="currentColor"
    />
  </svg>
);

const HoursWorkedIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 10.75C20 5.64137 15.8586 1.5 10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75ZM21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0C16.6871 0 21.5 4.81294 21.5 10.75Z"
      fill="currentColor"
    />
    <path
      d="M10 4.75C10 4.33579 10.3358 4 10.75 4C11.1642 4 11.5 4.33579 11.5 4.75V10.2861L15.085 12.0791C15.4553 12.2643 15.6058 12.7146 15.4209 13.085C15.2357 13.4553 14.7854 13.6058 14.415 13.4209L10.415 11.4209C10.161 11.2939 10 11.0341 10 10.75V4.75Z"
      fill="currentColor"
    />
  </svg>
);

const CompletedWorkOrdersIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 10.75C20 5.64137 15.8586 1.5 10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75ZM21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0C16.6871 0 21.5 4.81294 21.5 10.75Z"
      fill="currentColor"
    />
    <path
      d="M13.2197 8.21973C13.5126 7.92683 13.9874 7.92683 14.2803 8.21973C14.5732 8.51262 14.5732 8.98738 14.2803 9.28027L10.2803 13.2803C9.98738 13.5732 9.51262 13.5732 9.21973 13.2803L7.21973 11.2803C6.92683 10.9874 6.92683 10.5126 7.21973 10.2197C7.51262 9.92683 7.98738 9.92683 8.28027 10.2197L9.75 11.6895L13.2197 8.21973Z"
      fill="currentColor"
    />
  </svg>
);

const RefrigerantIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.48828 14.5C7.77287 14.4954 8.04043 14.6541 8.1709 14.915L9.4209 17.415C9.60584 17.7854 9.45531 18.2357 9.08496 18.4209C8.71455 18.6058 8.26428 18.4553 8.0791 18.0849L7.08008 16.0879L4.88379 16.4883C4.47641 16.5621 4.08579 16.2912 4.01172 15.8838C3.93789 15.4764 4.20882 15.0858 4.61621 15.0117L7.36621 14.5117L7.48828 14.5Z"
      fill="currentColor"
    />
    <path
      d="M8.0791 1.41502C8.26428 1.04466 8.71455 0.89414 9.08496 1.07908C9.45531 1.26426 9.60584 1.71453 9.4209 2.08494L8.1709 4.58494C8.02189 4.88295 7.69402 5.04767 7.36621 4.98826L4.61621 4.48826C4.20882 4.41419 3.93789 4.02357 4.01172 3.61619C4.08579 3.2088 4.47641 2.93787 4.88379 3.0117L7.08008 3.41111L8.0791 1.41502Z"
      fill="currentColor"
    />
    <path
      d="M14.1338 14.5117L16.8838 15.0117C17.2912 15.0858 17.5621 15.4764 17.4883 15.8838C17.4142 16.2912 17.0236 16.5621 16.6162 16.4883L14.4189 16.0879L13.4209 18.0849C13.2357 18.4553 12.7854 18.6058 12.415 18.4209C12.0447 18.2357 11.8942 17.7854 12.0791 17.415L13.3291 14.915C13.4781 14.617 13.806 14.4523 14.1338 14.5117Z"
      fill="currentColor"
    />
    <path
      d="M12.415 1.07908C12.7854 0.89414 13.2357 1.04466 13.4209 1.41502L14.4189 3.41111L16.6162 3.0117C17.0236 2.93787 17.4142 3.2088 17.4883 3.61619C17.5621 4.02357 17.2912 4.41419 16.8838 4.48826L14.1338 4.98826C13.806 5.04767 13.4781 4.88295 13.3291 4.58494L12.0791 2.08494C11.8942 1.71453 12.0447 1.26426 12.415 1.07908Z"
      fill="currentColor"
    />
    <path
      d="M12.75 12C13.0341 12 13.2939 12.1609 13.4209 12.415L16.4209 18.415C16.6058 18.7854 16.4553 19.2357 16.085 19.4209C15.7146 19.6058 15.2643 19.4553 15.0791 19.0849L12.2861 13.5H8.75C8.33579 13.5 8 13.1642 8 12.75C8 12.3358 8.33579 12 8.75 12H12.75Z"
      fill="currentColor"
    />
    <path
      d="M15.0791 0.415019C15.2643 0.0446649 15.7146 -0.10586 16.085 0.079081C16.4553 0.264258 16.6058 0.714531 16.4209 1.08494L13.5879 6.74998L14.9209 9.41502C15.1058 9.78543 14.9553 10.2357 14.585 10.4209C14.2146 10.6058 13.7643 10.4553 13.5791 10.0849L12.0791 7.08494C11.9738 6.87401 11.9738 6.62595 12.0791 6.41502L15.0791 0.415019Z"
      fill="currentColor"
    />
    <path
      d="M8.0791 6.41502C8.26428 6.04467 8.71455 5.89414 9.08496 6.07908C9.45531 6.26426 9.60584 6.71453 9.4209 7.08494L7.9209 10.0849C7.79385 10.339 7.53408 10.5 7.25 10.5H0.75C0.335786 10.5 0 10.1642 0 9.74998C0 9.33577 0.335786 8.99998 0.75 8.99998H6.78613L8.0791 6.41502Z"
      fill="currentColor"
    />
    <path
      d="M18.1504 7.29978C18.399 6.96868 18.8689 6.90192 19.2002 7.15037C19.5313 7.39896 19.5981 7.86891 19.3496 8.20017L18.1865 9.74998L19.3496 11.2998C19.5981 11.6311 19.5313 12.101 19.2002 12.3496C18.8689 12.598 18.399 12.5313 18.1504 12.2002L16.6504 10.2002C16.4504 9.93351 16.4504 9.56645 16.6504 9.29978L18.1504 7.29978Z"
      fill="currentColor"
    />
    <path
      d="M20.75 8.99998C21.1642 8.99998 21.5 9.33577 21.5 9.74998C21.5 10.1642 21.1642 10.5 20.75 10.5H14.7139L13.4209 13.0849C13.2357 13.4553 12.7854 13.6058 12.415 13.4209C12.0447 13.2357 11.8942 12.7854 12.0791 12.415L13.5791 9.41502C13.7061 9.16093 13.9659 8.99998 14.25 8.99998H20.75Z"
      fill="currentColor"
    />
    <path
      d="M2.2998 7.15037C2.63107 6.90192 3.10102 6.96868 3.34961 7.29978L4.84961 9.29978C5.04961 9.56645 5.04961 9.93351 4.84961 10.2002L3.34961 12.2002C3.10102 12.5313 2.63107 12.598 2.2998 12.3496C1.9687 12.101 1.90194 11.6311 2.15039 11.2998L3.3125 9.74998L2.15039 8.20017C1.90194 7.86891 1.9687 7.39896 2.2998 7.15037Z"
      fill="currentColor"
    />
    <path
      d="M6.91504 9.07908C7.28545 8.89414 7.73572 9.04467 7.9209 9.41502L9.4209 12.415C9.52621 12.626 9.52621 12.874 9.4209 13.0849L6.4209 19.0849C6.23572 19.4553 5.78545 19.6058 5.41504 19.4209C5.04469 19.2357 4.89416 18.7854 5.0791 18.415L7.91113 12.75L6.5791 10.0849C6.39416 9.71453 6.54469 9.26426 6.91504 9.07908Z"
      fill="currentColor"
    />
    <path
      d="M5.41504 0.079081C5.78545 -0.10586 6.23572 0.0446649 6.4209 0.415018L9.21387 5.99998H12.75C13.1642 5.99998 13.5 6.33577 13.5 6.74998C13.5 7.16419 13.1642 7.49998 12.75 7.49998H8.75C8.46592 7.49998 8.20615 7.33903 8.0791 7.08494L5.0791 1.08494C4.89416 0.71453 5.04469 0.264258 5.41504 0.079081Z"
      fill="currentColor"
    />
  </svg>
);

const RecommendationsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.25 8C17.25 6.60761 16.6965 5.27265 15.7119 4.28809C14.7273 3.30352 13.3924 2.75 12 2.75C10.6076 2.75 9.27265 3.30352 8.28809 4.28809C7.30352 5.27265 6.75 6.60761 6.75 8C6.75 8.85319 6.90392 9.84337 8.03027 10.9697C8.77237 11.7118 9.49274 12.64 9.73535 13.8525C9.81656 14.2586 9.55342 14.6539 9.14746 14.7354C8.74142 14.8166 8.34605 14.5534 8.26465 14.1475C8.10719 13.3602 7.62755 12.6881 6.96973 12.0303C5.49608 10.5566 5.25 9.14681 5.25 8C5.25 6.20979 5.96069 4.49243 7.22656 3.22656C8.49243 1.96069 10.2098 1.25 12 1.25C13.7902 1.25 15.5076 1.96069 16.7734 3.22656C18.0393 4.49243 18.75 6.20979 18.75 8C18.75 9.47307 18.1877 10.9722 17.0303 12.0303C16.2799 12.7807 15.8941 13.3538 15.7354 14.1475C15.6539 14.5534 15.2586 14.8166 14.8525 14.7354C14.4466 14.6539 14.1834 14.2586 14.2646 13.8525C14.506 12.6464 15.1202 11.8192 15.9697 10.9697L15.998 10.9424C16.8209 10.2019 17.25 9.11459 17.25 8Z"
      fill="currentColor"
    />
    <path
      d="M15 17.25C15.4142 17.25 15.75 17.5858 15.75 18C15.75 18.4142 15.4142 18.75 15 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18C8.25 17.5858 8.58579 17.25 9 17.25H15Z"
      fill="currentColor"
    />
    <path
      d="M14 21.25C14.4142 21.25 14.75 21.5858 14.75 22C14.75 22.4142 14.4142 22.75 14 22.75H10C9.58579 22.75 9.25 22.4142 9.25 22C9.25 21.5858 9.58579 21.25 10 21.25H14Z"
      fill="currentColor"
    />
  </svg>
);

// Ad-hoc report cards. `type` maps to AD_HOC_REPORT_TYPES values in GenerateReportModal.
const REPORT_CARDS = [
  {
    type: 0,
    title: "Open Work Orders",
    description: "View active work orders across selected branches and date ranges. Track progress and bottlenecks.",
    category: "Operations",
    categoryClass: "bg-[#EAF3FF] text-[#0058E5]",
    icon: OpenWorkOrdersIcon,
    iconClass: "bg-[#EAF3FF] text-[#0058E5]",
    footer: "Last generated 2h ago",
  },
  {
    type: 20,
    title: "Hours Worked",
    description: "Export technician hours for payroll, workforce tracking, and reporting. Supports custom date ranges.",
    category: "Payroll",
    categoryClass: "bg-[#DCFCE7] text-[#15803D]",
    icon: HoursWorkedIcon,
    iconClass: "bg-[#DCFCE7] text-[#15803D]",
    footer: "Last generated yesterday",
  },
  {
    type: 1,
    title: "Completed Work Orders",
    description:
      "Review completed jobs and operational performance across teams. Includes quality scores and resolution times.",
    category: "Operations",
    categoryClass: "bg-[#EAF3FF] text-[#0058E5]",
    icon: CompletedWorkOrdersIcon,
    iconClass: "bg-[#F3E8FF] text-[#7E22CE]",
    footer: "Last generated 4d ago",
  },
  {
    type: "refrigerant",
    title: "Refrigerant Report",
    description:
      "Track refrigerant usage and materials sold to customers. Essential for environmental compliance and inventory auditing.",
    category: "Operations",
    categoryClass: "bg-[#EAF3FF] text-[#0058E5]",
    icon: RefrigerantIcon,
    iconClass: "bg-[#FFEDD5] text-[#C2410C]",
    footer: "NEW",
    footerClass: "text-[#0058E5] font-OpenSansSemiBold uppercase",
  },
  {
    type: "recommendations",
    title: "Recommendations",
    description:
      "Generate a report of recommendations filtered by branch, customer, location, work order, technician, and date range.",
    category: "Operations",
    categoryClass: "bg-[#EAF3FF] text-[#0058E5]",
    icon: RecommendationsIcon,
    iconClass: "bg-[#E0F2FE] text-[#0369A1]",
    footer: "NEW",
    footerClass: "text-[#0058E5] font-OpenSansSemiBold uppercase",
  },
];

/**
 * Ad-Hoc tab body: a grid of report cards. Each card's "Generate Report"
 * button opens GenerateReportModal for that report type.
 */
const AdHoc = ({ userArray = [] }) => {
  const [activeType, setActiveType] = useState(null);
  const [refrigerantShown, setRefrigerantShown] = useState(false);
  const [recommendationsShown, setRecommendationsShown] = useState(false);

  // Viewing this tab needs report:adHocRead; actually generating a report needs
  // report:adHocGenerate, which gates the per-card action button.
  const canGenerate = can("report:adHocGenerate");

  // The refrigerant and recommendations reports have their own multi-step modals;
  // the rest share GenerateReportModal.
  const openCard = (type) => {
    if (type === "refrigerant") {
      setRefrigerantShown(true);
    } else if (type === "recommendations") {
      setRecommendationsShown(true);
    } else {
      setActiveType(type);
    }
  };

  return (
    <div className="w-full">
      <GenerateReportModal
        shown={activeType !== null}
        onClose={() => setActiveType(null)}
        userArray={userArray}
        reportType={activeType ?? 0}
      />

      <RefrigerantReportModal
        shown={refrigerantShown}
        onClose={() => setRefrigerantShown(false)}
        userArray={userArray}
      />

      <RecommendationsReportModal
        shown={recommendationsShown}
        onClose={() => setRecommendationsShown(false)}
        userArray={userArray}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {REPORT_CARDS.map((card) => {
          const Icon = card.icon;
          const isNew = card.footer === "NEW";
          return (
            <div
              key={card.type}
              className="bg-white p-6 rounded-[12px] outline outline-1 -outline-offset-1 outline-[#E5E8F3] shadow-[0px_1px_2px_rgba(0,0,0,0.05)] flex flex-col gap-4"
            >
              <div className="flex items-start justify-between">
                <div
                  className={`w-[48px] h-[48px] p-3 rounded-[12px] flex items-center justify-center ${card.iconClass}`}
                >
                  <Icon size={24} />
                </div>
                <span
                  className={`px-2 py-0.5 rounded-[6px] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] capitalize ${card.categoryClass}`}
                >
                  {card.category}
                </span>
              </div>

              <div className="flex flex-col gap-1.5 pb-2">
                <p className="font-OpenSansSemiBold text-[18px] leading-[28px] text-[#1A2332] capitalize">
                  {card.title}
                </p>
                <p className="font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] text-[#5F6477]">
                  {card.description}
                </p>
              </div>

              <div className="border-t-[1px] border-[#EEF0F9] pt-4 flex items-center justify-between">
                <span
                  className={`flex items-center gap-1.5 text-[12px] leading-[18px] tracking-[0.12px] ${card.footerClass || "font-OpenSansRegular text-[#7C829A]"}`}
                >
                  {/* {!isNew && <LuClock size={12} className="text-[#7C829A]" />}
                  {card.footer} */}
                </span>
                {canGenerate && (
                  <button
                    type="button"
                    disabled={card.disabled}
                    onClick={() => !card.disabled && openCard(card.type)}
                    className={`h-[40px] px-4 rounded-[8px] bg-white outline outline-1 -outline-offset-1 outline-[#C9CEE2] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-OpenSansSemiBold text-[16px] leading-[24px] capitalize ${
                      card.disabled ? "text-inputFieldTextColor cursor-not-allowed" : "text-[#1A2332] hover:bg-[#F7F9FC]"
                    }`}
                  >
                    Generate report
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdHoc;
